import { render, staticRenderFns } from "./RankedBarList.vue?vue&type=template&id=352c0842&scoped=true&"
import script from "./RankedBarList.vue?vue&type=script&lang=js&"
export * from "./RankedBarList.vue?vue&type=script&lang=js&"
import style0 from "./RankedBarList.vue?vue&type=style&index=0&id=352c0842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c0842",
  null
  
)

export default component.exports